import { render, staticRenderFns } from "./ModalMedicamentos.vue?vue&type=template&id=c2cffdec"
import script from "./ModalMedicamentos.vue?vue&type=script&lang=js"
export * from "./ModalMedicamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports